import React from 'react';
import queryString from 'query-string';
import { FormGroup, Row, Col } from 'react-bootstrap';
import { Label, Button, ValidationError } from 'fw/components';
import { Form, PasswordBox, TextBox, EmailBox } from 'fw/forms';
import Loading from 'layouts/public/loading/Loading'
import Completed from 'layouts/public/completed/Completed'
import { PasswordInstructions } from 'areas/shared/components';
import * as Notifications from 'fw/globals/Notifications';
import * as API from 'modules/app/API'

class UserRegistration extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState();
    }

    initialState = () => {
        return {
            error: null,
            loading: true,
            completed: false,
            loginIsEmpty: false
        }
    }

    retrieveRegistration = () => {
        const rq = {
            registrationToken: queryString.parse(this.props.location.search).p
        }

        API.Security.get('/registration/retrieveRegistration', rq,
            {
                success: (sr) => {
                   // Set initial state
                    this.setState({
                        loading: false,
                        loginIsEmpty: (sr.data.login === null || sr.data.login === ""),
                        form: {
                            login: sr.data.login,
                            email: sr.data.email,
                            password: "",
                            confirmPassword: ""
                        },
                        data: {
                            firstName: sr.data.firstName
                        }
                    });
                },
                error: (sr) => {
                    this.setState({
                        loading: false,
                        error: sr.error
                    })
                }
            });
    }

    completeRegistration = () => {
        if (!this.validate())
            return;

        const rq = {
            registrationToken: queryString.parse(this.props.location.search).p,
            // For security reasons login is sent only when it needs to be set
            setLogin: this.state.loginIsEmpty,
            login: this.state.loginIsEmpty ? this.state.form.login : "",
            password: this.state.form.password,
        };

        API.Security.post('/registration/completeRegistration', rq,
            {
                success: (sr) => {
                    this.setState({ completed: true });
                },
                error: (sr) => {
                    if (sr.error.erroCode === 'INVALID_TOKEN') {
                        this.setState({
                            loading: false,
                            error: sr.error
                        });
                    }
                    else
                        Notifications.error(sr.error.errorMessage);
                }
            });
    }

    validate() {
        const form = this.state.form;

        if (form.password !== form.confirmPassword) {
            Notifications.error("The password and confirmation password do not match");
            return false;
        }

        return true;
    }


    componentDidMount() {
        this.retrieveRegistration();
    }

    onSubmit = (form) => {
        this.completeRegistration();
    }

    onChange = (form) => {
        this.setState({ form });
    }

    render() {
        if (this.state.loading) {
            return (<Loading />)
        }
        else if (this.state.error) {
            return <ValidationError error={this.state.error} />
        }
        else if (this.state.completed) {
            return (<Completed
                title="Registration complete."
                message="You have been successfully registered. Ready to start?" />)
        }

        return (
            <React.Fragment>
                <p className="login-box-heading"><strong>Welcome aboard {this.state.data.firstName}!</strong> Please use the form below to create your system password.</p>
                <hr />
                <Form
                    onSubmit={this.onSubmit}
                    onChange={this.onChange}
                    values={this.state.form}>
                    <Row>
                        <Col md={7}>
                            <FormGroup>
                                <Label htmlFor="login" required={this.state.loginIsEmpty}>Your User Name is:</Label>
                                <TextBox name="login" disabled={!this.state.loginIsEmpty} required={this.state.loginIsEmpty} />
                            </FormGroup>
                        </Col>
                        <Col md={5}>
                            <FormGroup>
                                <Label htmlFor="email">Email</Label>
                                <EmailBox name="email" disabled />
                            </FormGroup>
                        </Col>
                    </Row>
                    <hr />
                    <Row>
                        <Col md={7}>
                            <FormGroup>
                                <Label htmlFor="password" required>Enter your password</Label>
                                <PasswordBox name="password" required autofocus />
                            </FormGroup>
                            <FormGroup>
                                <Label htmlFor="confirmPassword" required>Confirm your password</Label>
                                <PasswordBox name="confirmPassword" required />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <PasswordInstructions />
                        </Col>
                    </Row>
                    <hr />
                    <hr style={{ marginTop: "10px" }} />
                    <FormGroup className="text-center">
                        <Button id="btnFinish" type="submit" bsClass="btn btn-primary btn-flat">Finish your registration</Button>
                    </FormGroup>
                </Form>
            </React.Fragment>
        );
    }
}

export default UserRegistration;



// WEBPACK FOOTER //
// ./src/areas/public/userRegistration/UserRegistration.js